import { render } from "./ModalExchange.vue?vue&type=template&id=793ec607&scoped=true"
import script from "./ModalExchange.vue?vue&type=script&lang=js"
export * from "./ModalExchange.vue?vue&type=script&lang=js"

import "./ModalExchange.vue?vue&type=style&index=0&id=793ec607&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793ec607"]])

export default __exports__